import SDIcon from '../SDIcon'

const IconGoogleCalendar = ({ size = 32, ...props }) => (
  <SDIcon title='Google Calendar' viewBox='0 0 48 48' {...props} size={size}>
    <rect x="4" y="6" width="40" height="38" rx="4" ry="4" fill="#ffffff" stroke="#dadce0"/>
    <rect x="4" y="6" width="40" height="8" fill="#1967d2" />
    <text
    x="24"
    y="34"
    textAnchor="middle"
    fontSize="18"
    fontWeight="bold"
    fill="#1967d2"
    fontFamily="Arial, sans-serif"
    >
    31
    </text>
  </SDIcon>
)

export default IconGoogleCalendar
